// Feature flags — flip these on once the corresponding backend support ships.
// Values are read from Vue CLI env vars (VUE_APP_*) so ops can toggle without a rebuild
// by setting the variable at deploy time.

function envFlag (name, defaultValue) {
  var raw = process.env[name]
  if (raw === undefined || raw === null || raw === '') return defaultValue
  var v = String(raw).toLowerCase()
  return v === '1' || v === 'true' || v === 'yes' || v === 'on'
}

// Manual field-measurement entry + Historical CSV import. Requires the leafsvc backend
// to expose the ManualReading GraphQL type + REST import endpoints. Set
// VUE_APP_MANUAL_READINGS_ENABLED=1 in the environment once the API supports it.
export const MANUAL_READINGS_ENABLED = envFlag('VUE_APP_MANUAL_READINGS_ENABLED', false)

// River device type + its sensor-data view. On by default as of leafsvc 0.8.0, which
// added the SensorRiver table and accepts `type: "river"` on the metrics query.
// Set VUE_APP_RIVER_ENABLED=0 to hide the nav entry and drop `river` from the
// device-type dropdowns — e.g. when pointing at an older API.
export const RIVER_ENABLED = envFlag('VUE_APP_RIVER_ENABLED', true)
